// API Calls
export const CLAIMS_GET_REQUEST = 'CLAIMS_GET_REQUEST';
export const CLAIMS_GET_SUCCESS = 'CLAIMS_GET_SUCCESS';
export const CLAIMS_GET_FAILURE = 'CLAIMS_GET_FAILURE';

